import { createContext } from "react";

import { RouteProps } from "@/contexts/RouteContext";

export type AppBridgeContextValue = RouteProps & {
  isVisible: boolean;
};

export const AppBridgeContext = createContext<AppBridgeContextValue | null>(null);
